import apiClient from '../../shared/services/apiClient';

/**
 * CDN 节点运维(Rust 边缘):重载配置 / 密钥查看与轮换 / 同步状态时间窗。
 * 与 cdnService 分开,避免与其它会话的改动冲突。
 */
const wrap = async (fn) => {
  try {
    const response = await fn();
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

const cdnNodeOpsService = {
  /** 节点立即回拉全量配置(typed task node_command{cmd:reload}) */
  reloadNode(id) {
    return wrap(() => apiClient.post('/api/admin/nodes/reload', { id }));
  },

  /** 取 sync_key 明文 + edge.env 片段(复制用) */
  revealKey(id) {
    return wrap(() => apiClient.post('/api/admin/nodes/reveal-key', { id }));
  },

  /** 轮换 sync_key;节点 /opt/edge/edge.env 的 NODE_SECRET 必须同步更新 */
  rotateKey(id) {
    return wrap(() => apiClient.post('/api/admin/nodes/rotate-key', { id }));
  },

  /** 节点列表(含 health / ws / tasks_24h / regions) */
  getNodes(params = {}) {
    return wrap(() => apiClient.get('/api/admin/nodes', { params }));
  },

  /** 每节点任务同步状态,since_hours 默认 24,0=全部 */
  getSyncStatus(params = {}) {
    return wrap(() => apiClient.get('/api/admin/nodes/sync-status', { params }));
  },

  /** 节点多 IP:列表(含逐 IP 健康 + 当前 DNS 应发布的 IP) */
  listNodeIps(nodeId) {
    return wrap(() => apiClient.get('/api/admin/cdn/node-ips', { params: { node_id: nodeId } }));
  },

  /** 全网 IP 池 {node_id?, role?, health?, q?} */
  getIpPool(params = {}) {
    return wrap(() => apiClient.get('/api/admin/cdn/ip-pool', { params }));
  },

  /** IP 子池 */
  listIpPools() {
    return wrap(() => apiClient.get('/api/admin/cdn/ip-pools'));
  },

  saveIpPool(data) {
    return wrap(() => apiClient.post('/api/admin/cdn/ip-pools/save', data));
  },

  deleteIpPool(id) {
    return wrap(() => apiClient.post('/api/admin/cdn/ip-pools/delete', { id }));
  },

  addPoolMembers(poolId, nodeIpIds) {
    return wrap(() => apiClient.post('/api/admin/cdn/ip-pools/members/add', { pool_id: poolId, node_ip_ids: nodeIpIds }));
  },

  /** {id, preferred?, weight?} */
  updatePoolMember(data) {
    return wrap(() => apiClient.post('/api/admin/cdn/ip-pools/members/update', data));
  },

  removePoolMember(id) {
    return wrap(() => apiClient.post('/api/admin/cdn/ip-pools/members/remove', { id }));
  },

  /** 线路记录选用的子池 {pool_ids, pools} */
  getLinePools(lineRecordId) {
    return wrap(() => apiClient.get('/api/admin/cdn/line-record-pools', { params: { line_record_id: lineRecordId } }));
  },

  saveLinePools(lineRecordId, poolIds) {
    return wrap(() => apiClient.post('/api/admin/cdn/line-record-pools/save', { line_record_id: lineRecordId, pool_ids: poolIds }));
  },

  createNodeIp(data) {
    return wrap(() => apiClient.post('/api/admin/cdn/node-ips/create', data));
  },

  /** {id, ddos_gbps} */
  updateNodeIp(data) {
    return wrap(() => apiClient.post('/api/admin/cdn/node-ips/update', data));
  },

  deleteNodeIp(id) {
    return wrap(() => apiClient.post('/api/admin/cdn/node-ips/delete', { id }));
  },
};

export default cdnNodeOpsService;
